import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { memo } from 'react';
import { useFormContext } from '../../contexts/FormContext';
import { useFieldValue } from '../../hooks/useFormValues';

const CheckBoxField = ({ field }: { field: any }) => {
  const { handleChange } = useFormContext();
  const value = useFieldValue(field.name);

  return (
    <Grid size={field.size || 12} key={field.name}>
      <FormControlLabel
        control={
          <Checkbox
            checked={value || false}
            onChange={(e) =>
              handleChange({ target: { name: field.name, value: e.target.value, type: e.target.type, checked: e.target.checked } }, field)
            }
            inputProps={{ 'aria-label': 'controlled' }}
          />
        }
        label={<Typography color={'text.primary'}>{field.label}</Typography>}
      />
    </Grid>
  );
};

export default memo(CheckBoxField);
